import React from 'react';

import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Row,
	Col,
} from 'reactstrap';
import moment from 'moment';

import PropTypes from 'prop-types';
import { symbolPriceFormatter } from '~/helpers/price';
import { Text } from '~/components/Text';

export function ModalDetalheRecebimento(props) {
	const { isOpen, toggle, recebimento } = props;

	return (
		<Modal isOpen={isOpen} toggle={toggle}>
			<ModalHeader>
				{moment(recebimento.data_consulta).format('DD/MM/YYYY')}
			</ModalHeader>
			<ModalBody>
				<Row className="border-bottom pb-3">
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Valor total:
						</Text>
						{recebimento.total_bruto !== undefined ? (
							<Text color="gray">
								{symbolPriceFormatter(recebimento.total_bruto)}
							</Text>
						) : (
							<Text color="gray">
								{symbolPriceFormatter(recebimento.valor_bruto)}
							</Text>
						)}
					</Col>
				</Row>
				<Row className="border-bottom py-3">
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Débito:
						</Text>
						<Text color="gray">
							{symbolPriceFormatter(recebimento.total_debito)}
						</Text>
					</Col>
				</Row>
				<Row className="border-bottom py-3">
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Crédito à vista:
						</Text>
						<Text color="gray">
							{symbolPriceFormatter(recebimento.total_credito)}
						</Text>
					</Col>
				</Row>
				<Row className="border-bottom py-3">
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Crédito parcelado:
						</Text>
						<Text color="gray">
							{symbolPriceFormatter(recebimento.total_parcelado)}
						</Text>
					</Col>
				</Row>
				<Row className="border-bottom py-3">
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Descontos:
						</Text>
						{recebimento.total_desconto !== undefined ? (
							<Text color="red">
								{`- ${symbolPriceFormatter(
									recebimento.total_desconto
								)}`}
							</Text>
						) : (
							<Text color="red">
								{`- ${symbolPriceFormatter(
									recebimento.valor_desconto
								)}`}
							</Text>
						)}
					</Col>
				</Row>
				<Row className="border-bottom py-3">
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Líquido:
						</Text>
						<Text color="green" weight="bold">
							{symbolPriceFormatter(recebimento.total_liquido)}
						</Text>
					</Col>
				</Row>
			</ModalBody>
			<ModalFooter>
				<Button onClick={toggle} color="primary">
					Ok
				</Button>
			</ModalFooter>
		</Modal>
	);
}

ModalDetalheRecebimento.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	toggle: PropTypes.func.isRequired,
	recebimento: PropTypes.oneOfType([PropTypes.object]),
};

ModalDetalheRecebimento.defaultProps = {
	recebimento: {},
};
